export const skillsConfig = {
  orchHeading: 'Orchestration & LLM systems',
  orchSkills: [
    { label: 'LangGraph' },
    { label: 'LangChain' },
    { label: 'LLM APIs' },
    { label: 'Prompts' },
    { label: 'Multi-agent routing' },
    { label: 'RAG' },
    { label: 'Guardrails & PII' },
    { label: 'Recoveries' },
  ],
  jsHeading: 'Javascript Full Stack',
  jsSkills: [
    { label: 'ReactJs', tooltip: 'ReactJs', href: 'https://react.dev/' },
    { label: 'webpack', tooltip: 'webpack', href: 'https://webpack.js.org/' },
    { label: 'NodeJs + Express', tooltip: 'NodeJs + Express', href: 'https://nodejs.org/' },
    { label: 'Solid JS', tooltip: 'Solid JS', href: 'https://www.solidjs.com/' },
    { label: 'Angular', tooltip: 'Angular', href: 'https://angular.io/' },
  ],
  msHeading: 'Microservices & Microfrontends',
  msSkills: [
    { label: 'Kubernetes', tooltip: 'Kubernetes', href: 'https://kubernetes.io/' },
    { label: 'Docker', tooltip: 'Docker', href: 'https://www.docker.com/' },
    {
      label: 'Module Federation',
      tooltip: 'Module Federation',
      href: 'https://webpack.js.org/concepts/module-federation/',
    },
  ],
  aiHeading: 'Agentic AI Coding',
  aiSkills: [
    {
      label: 'Claude Code',
      tooltip: 'Claude Code',
      href: 'https://claude.com/product/claude-code',
    },
    { label: 'Cursor AI', tooltip: 'Cursor AI', href: 'https://www.cursor.com/' },
    { label: 'Opencode', tooltip: 'Opencode', href: 'https://opencode.ai/' },
    {
      label: 'GitHub Copilot',
      tooltip: 'GitHub Copilot',
      href: 'https://github.com/features/copilot',
    },
    { label: 'AMP Code', tooltip: 'AMP Code', href: 'https://ampcode.com/' },
    { label: 'Lovable', tooltip: 'Lovable', href: 'https://lovable.dev/' },
  ],
};
